<template>
  <div class="pt-10 pb-5">
    <Sidebar></Sidebar>
    <Header>{{$t('all.calendar')}}</Header>
    <div class="bg-pink p-16 py-5 text-center block">
      <div class="flex items-baseline">
        <div class="relative flex-1">
          <div
            class="w-10 h-10 absolute rounded-full z-1 -mt-12 -ml-12"
            :class="'bg-' + evaluateMinor"
            style="top:50%; left:50%;"
          >
          </div>
          <router-link
            class="h-120 w-120"
            :to="{name: 'MinoreDettaglio', params:{'id': minor.id}}"
          >
            <img
              class="w-24 h-24 rounded-full border-4 align-middle z-3 relative"
              :class="'border-' + evaluateMinor"
              src="/img/user.png"
            >
          </router-link>
        </div>
      </div>
      <h3 class="pt-5 text-pink-dark">{{ minor.name }} {{ minor.surname }}</h3>
    </div>
    <div class="bg-white pb-10 px-4 h-screen">
      <div class="container mx-auto py-4">
        <!-- Calendario -->
        <div class="pb-2 m-b-2 border-b-2 border-dashed border-pink overflow-auto h-32 ">
          <div>{{ printDate() }}</div>
          <div
            v-if="expectedAbsence"
            class="pt-1 pb-1"
          >
            <span class="text-sm pt-1 pb-1"><b>{{$t('all.class_absence')}}</b><br>{{$t('all.class_absence_reported')}} {{ calendar[day].expected_absence.tutor_name }}</span>
          </div>
          <div v-show="calendar && calendar[day]">
            <div
              v-for="event in getEvents"
              :key="event.id"
              class="pt-1 pb-1"
            >
              <span class="text-sm"><b>{{ elaborateDate(event.timestamp) }}</b> {{ getTranslation(event) }} </span>
            </div>
          </div>
        </div>

        <div class="flex">
          <div
            class="w-10 text-center text-sm py-4 pb-6 cursor-pointer"
            @click="changeDate('rem')"
          ><i class="fas fa-angle-left"></i></div>
          <div class="flex-1 w-10 text-center text-sm py-4 pb-6">
            {{ months[month - 1] }} {{ year }}
          </div>
          <div
            class="w-10 text-center text-sm py-4 pb-6 cursor-pointer"
            @click="changeDate('add')"
          ><i class="fas fa-angle-right"></i></div>
        </div>

        <div>
          <ul class="list-reset">
            <li
              v-for="das in days"
              :key="das.id"
              class="float-left text-center bold w-1/7 p-1"
            ><span class="text-grey-light text-sm">{{ das }}</span></li>
          </ul>
        </div>
        <ul class="list-reset">
          <li
            v-if="firstDay > 0"
            v-for="index in firstDay"
            :key="index.id"
            class="float-left w-1/7 text-center bold p-1"
          >&nbsp;</li>
          <li
            v-for="(d, index) in calendar"
            :key="d.id"
            class="float-left w-1/7 text-center bold my-3"
            style="height:20px;"
          >
            <span
              @click="selectDay(index)"
              v-if="index != day"
              :class="{'text-pink': d.festivity.isFestivity, 'bg-blue-dark rounded-full text-white': activeDay(index)}"
              class="text-sm py-1 pt-2"
              style="width:22px; display:inline-block;"
            >{{ index }}</span>
            <span
              @click="selectDay(index)"
              v-if="index == day"
              class="py-1 pt-2 bg-pink rounded-full text-white text-sm"
              style="width:22px; display:inline-block;"
            >{{ index }}</span>
          </li>
        </ul>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import { authService } from '@/services';
import { mapGetters, mapActions } from 'vuex';
import { evaluateMinor } from '@/mixins/minore.mixins';
import filter from 'lodash/filter';

const d = new Date();
const n = d.getDate();
const y = d.getFullYear();
const m = d.getMonth() + 1;

export default {
  props: ['id'],
  mixins: [evaluateMinor],
  data() {
    return {
      year: y,
      month: m,
      day: n,
      days: [
        `${this.$t('all.mon')}`,
        `${this.$t('all.tue')}`,
        `${this.$t('all.wed')}`,
        `${this.$t('all.thu')}`,
        `${this.$t('all.fri')}`,
        `${this.$t('all.sat')}`,
        `${this.$t('all.sun')}`,
      ],
      months: [
        `${this.$t('all.january')}`,
        `${this.$t('all.february')}`,
        `${this.$t('all.march')}`,
        `${this.$t('all.april')}`,
        `${this.$t('all.may')}`,
        `${this.$t('all.june')}`,
        `${this.$t('all.july')}`,
        `${this.$t('all.august')}`,
        `${this.$t('all.september')}`,
        `${this.$t('all.october')}`,
        `${this.$t('all.november')}`,
        `${this.$t('all.december')}`,
      ],
    };
  },
  computed: {
    ...mapGetters({
      calendar: 'calendar/calendar',
      minor: 'users/minor',
    }),
    firstDay() {
      const month = this.month;
      const year = this.year;
      const day = new Date(`${year}/${month}/01`).getDay() - 1;
      return day < 0 ? 6 : day;
    },
    expectedAbsence() {
      return (
        this.day &&
        this.calendar[this.day] &&
        this.calendar[this.day].expected_absence &&
        this.calendar[this.day].expected_absence.isExpectedAbsence
      );
    },
    getEvents() {
      if (!this.day) {
        return [];
      }
      const events =
        this.calendar[this.day] && this.calendar[this.day].events
          ? this.calendar[this.day].events
          : [];
      return filter(
        events,
        event => event.event_type_id !== 2 && event.event_type_id !== 14,
      );
    },
  },
  methods: {
    ...mapActions('authentication', ['getUserInfo']),
    ...mapActions('users', ['getMinor']),
    ...mapActions('calendar', ['getCalendar']),
    getTranslation(key) {
      if (key.event_type == 'emergency_call_no_answer') {
        return `${this.$t(`all.${key.event_type}`)} (${key.name} ${key.phone})`;
      }
      if (key.event_type == 'emergency_call_answered') {
        return `${this.$t(`all.${key.event_type}`)} (${key.name} ${key.phone})`;
      }
      return this.$t(`all.${key.event_type}`);
    },
    printDate() {
      const d1 = new Date();
      const n = d1.getDate();
      const y = d1.getFullYear();
      const m1 = d1.getMonth();
      if (
        `${this.day} ${this.months[this.month - 1]} ${this.year}` ===
        `${n} ${this.months[m1]} ${y}`
      ) {
        return `${this.$t('all.today')} - ${this.day} ${
          this.months[this.month - 1]
        } ${this.year}`;
      }
      return `${this.day} ${this.months[this.month - 1]} ${this.year}`;
    },
    activeDay(index) {
      const selectedDate = this.$moment()
        .date(index)
        .month(this.month - 1)
        .year(this.year);
      return this.$moment().isSame(selectedDate, 'day');
    },
    async changeDate(val) {
      let { year, month, id } = this;
      if (val === 'add') {
        month += 1;
        if (month > 12) {
          month = 1;
          year += 1;
        }
      } else {
        month -= 1;
        if (month < 1) {
          month = 12;
          year -= 1;
        }
      }
      this.month = month;
      this.year = year;
      await this.getCalendar({ id, year, month });
    },
    selectDay(i) {
      this.day = i;
    },
    isActiveDay(i) {
      return this.day === i;
    },
    elaborateDate(data) {
      const orario = data.date.split(' ');
      const orarioFormattato = orario[1].split(':');
      return orarioFormattato[0] + ':' + orarioFormattato[1];
    },
  },
  async created() {
    const { year, month, id } = this;
    await this.getUserInfo();
    const role = authService.getRole();
    await this.getMinor({ id, role });
    this.getCalendar({ id, year, month });
  },
};
</script>
